<template>
  <div class="league-zone-menu">
    <div class="left-content">
      <div class="league-row">
        <div class="league-category" @click="goToCopyright">
          <img :src="copyrightIcon" alt="" />
          <span class="category-title">版权赛事</span>
        </div>
        <div class="league-items copyright-items">
          <div class="league-item" v-for="(league, index) in copyrightLeagues" :key="index" @click="navigateToLeague(league)">
            <img :src="league.icon" alt="" />
            <span>{{ league.name }}</span>
          </div>
        </div>
      </div>

      <div class="league-row">
        <div class="league-category" @click="goToTopFive">
          <img :src="topFiveIcon" alt="" />
          <span class="category-title">五大联赛</span>
        </div>
        <div class="league-items topfive-items">
          <div class="league-item" v-for="(league, index) in topFiveLeagues" :key="index" @click="navigateToLeague(league)">
            <img :src="league.icon" alt="" />
            <span>{{ league.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="right-content">
      <div class="app-download">
        <p class="download-title">{{ title }}APP下载</p>
        <div class="qr-code-container">
          <qrcode-vue :value="qrCodeUrl" :size="120" level="H" />
        </div>
        <p class="download-tips">扫描下载懂球体育AI APP</p>
        <a :href="url" class="download-link">{{ url }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watchEffect, getCurrentInstance, computed } from 'vue'
import { useRouter } from 'vue-router'
import QrcodeVue from 'qrcode.vue'
import { useConfigStore } from '@/stores/config'

export default {
  name: 'LeagueZone',
  components: {
    QrcodeVue
  },
  setup() {
    const router = useRouter()
    const { proxy } = getCurrentInstance()
    const configStore = useConfigStore()
    const url = proxy?.$config[__TEMPLATE__]?.url
    const title = proxy?.$config[__TEMPLATE__]?.title

    const qrCodeUrl = computed(() => {
      const channelId = localStorage.getItem('channelId') || 'default'
      const linkId = localStorage.getItem('linkId') || ''
      const baseUrl = configStore.downloadUrl || 'https://download.dbf666.com/'
      return `${baseUrl}?channel=${channelId}${linkId ? `&linkId=${linkId}` : ''}`
    })

    const goToCopyright = () => {
      router.push('/copyright-events')
    }

    const goToTopFive = () => {
      router.push('/top-five-leagues')
    }

    const navigateToLeague = (league) => {
      // 根据联赛类型跳转到相应页面，并传递联赛 ID
      if (league.type === 'copyright') {
        router.push({
          path: '/copyright-events',
          query: { league: league.id }
        })
      } else if (league.type === 'topfive') {
        router.push({
          path: '/top-five-leagues',
          query: { league: league.id }
        })
      }
    }

    return {
      qrCodeUrl,
      title,
      url,
      goToCopyright,
      goToTopFive,
      navigateToLeague
    }
  },
  data() {
    // 辅助函数来获取图标路径
    const getIcon = (filename) => {
      try {
        return new URL(`/src/assets/icons/scoreboard/${filename}`, import.meta.url).href
      } catch (error) {
        console.warn(`Failed to load scoreboard icon: ${filename}`, error)
        return ''
      }
    }

    return {
      // 标题图标
      copyrightIcon: getIcon('sport1.webp'), // 使用足球图标
      topFiveIcon: getIcon('sport6.webp'),

      // 版权赛事数据
      copyrightLeagues: [
        { name: '日职联', icon: getIcon('sport2.webp'), type: 'copyright', id: 'j-league' },
        { name: '澳超', icon: getIcon('sport3.webp'), type: 'copyright', id: 'a-league' },
        { name: '韩K联', icon: getIcon('sport4.webp'), type: 'copyright', id: 'k-league' },
        { name: '日职乙', icon: getIcon('sport5.webp'), type: 'copyright', id: 'j2-league' }
      ],

      // 五大联赛数据
      topFiveLeagues: [
        { name: '英超', icon: getIcon('icon-yinchao.webp'), type: 'topfive', id: 'premier-league' },
        { name: '意甲', icon: getIcon('icon-yijia.webp'), type: 'topfive', id: 'serie-a' },
        { name: '西甲', icon: getIcon('icon-xijia.webp'), type: 'topfive', id: 'la-liga' },
        { name: '德甲', icon: getIcon('icon-dejia.webp'), type: 'topfive', id: 'bundesliga' },
        { name: '法甲', icon: getIcon('icon-fajia.webp'), type: 'topfive', id: 'ligue-1' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.league-zone-menu {
  background: $leagueZone-bg;
  border: 1px solid $leagueZone-border;
  border-radius: $leagueZone-radius;
  width: 100%;
  box-shadow: 0 10px 20px 0px $leagueZone-shadow-color;
  display: flex;
  padding: 30px;
  justify-content: space-between;
  align-items: flex-start;

  .left-content {
    flex: 1;
    max-width: 800px;
    margin-left: 150px;

    .league-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      .league-category {
        min-width: 140px;
        margin-right: 70px;
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
          width: 20px;
          margin-right: 10px;
        }

        .category-title {
          font-size: 22px;
          font-weight: normal;
          color: $text-primary;
          transition: color 0.2s ease;
          white-space: nowrap;

          &:hover {
            color: $color-primary;
          }
        }
      }

        .league-items {
          display: flex;
          flex-wrap: wrap;
          gap: 25px;
          align-items: flex-start;

        .league-item {
          font-size: 16px;
          color: $leagueZone-item-text;
          cursor: pointer;
          transition: color 0.2s ease;
          white-space: nowrap;
          display: flex;
          align-items: center;
          min-width: 80px;

          img {
            width: 20px;
            margin-right: 10px;
          }

          &:hover {
            color: $color-primary;
          }
        }
      }

      // 版权赛事：4个项目一行
      &.copyright-items {
        .league-item {
          width: calc(25% - 18.75px);
          flex: 0 0 auto;
        }
      }

      // 五大联赛：5个项目一行
      &.topfive-items {
        .league-item {
          width: calc(20% - 20px);
          flex: 0 0 auto;
        }
      }
    }
  }

  .right-content {
    width: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 270px;

    .app-download {
      text-align: center;
      display: flex;
      align-items: center;
      flex-direction: column;

      .qr-code-container {
        width: 120px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        background: $bg-card;
      }

      .download-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 24px;
        color: $text-primary;
        margin-bottom: 10px;
      }

      .download-tips {
        width: 210px;
        height: 36px;
        background: $color-primary;
        border-radius: 20px;
        font-weight: 800;
        font-size: 14px;
        color: $bg-white;
        line-height: 36px;
        text-align: center;
      }

      p {
        font-size: 20px;
        margin: 5px 0;
      }

      .download-link {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 14px;
        color: $color-primary;
        line-height: 16px;
        text-align: right;
        font-style: normal;
        text-decoration-line: underline;
        text-transform: none;
      }
    }
  }
}
</style>
